@if (searchable && !arregloMostrar[0].children) {
  <app-busqueda-option (valueChange)="filtrado($event)"/>
  <mat-divider/>
}

@for (item of arregloMostrar; track $index) {
  <div class="option"
    #origin="cdkOverlayOrigin"
    cdkOverlayOrigin
    (mouseenter)="openChildren(item, origin)">

    <app-options-select
      [element]="item"
      (selected)="selection(item)">
    </app-options-select>

  </div>
}

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="childrenOpen"
  [cdkConnectedOverlayOrigin]="currentOrigin"
  [cdkConnectedOverlayPositions]="positions">
  <div class="submenu">
    <app-tree-menu
      (selected)="selection($event)"
      [options]="currentChildren"
      [searchable]="searchable">
    </app-tree-menu>
  </div>
</ng-template>